import { connect } from 'react-redux';
import SEARCH_CONTEXT from '../../../helpers/InventorySearchContext';
import { getIsFetching } from '../../../redux/Inventory/selectors/tag';
import { getSearchQueryForContext } from '../../../redux/Inventory/selectors/components/search';
import {
  onChangeQuery,
  clearIventoryTags
} from '../../../redux/Inventory/actions';
import { fetchInventoryTags } from '../../../redux/Inventory/sagas/routines';
import InventorySearch from '../../../components/inventory/Search';

function mapStateToProps(state, props) {
  const searchQuery = getSearchQueryForContext(state, SEARCH_CONTEXT.TAG);
  return {
    ...props,
    query: searchQuery.q,
    queryOptions: { q: searchQuery.q },
    isFetching: getIsFetching(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: queryOptions => {
      dispatch(clearIventoryTags());
      dispatch(fetchInventoryTags(queryOptions));
    },
    onChange: query => {
      dispatch(onChangeQuery({ context: SEARCH_CONTEXT.TAG, query }));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventorySearch);
